import { Text } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import { DatabaseCalculationType } from '@databases/types/database/view';
import React from 'react';
import { useIntl } from 'react-intl-next';

interface DatabaseCalculationLabelProps {
  type?: DatabaseCalculationType;
  isButtonHeader?: boolean;
}

export const DatabaseCalculationLabel: React.FC<DatabaseCalculationLabelProps> = ({
  type,
  isButtonHeader = false,
}) => {
  const { formatMessage } = useIntl();

  const labelMap: Record<DatabaseCalculationType, string> = {
    [DatabaseCalculationType.SUM]: formatMessage(
      messages['quick-calculations.calculation-type-sum']
    ),
    [DatabaseCalculationType.COUNT]: formatMessage(
      messages['quick-calculations.calculation-type-count']
    ),
    [DatabaseCalculationType.COUNT_EMPTY]: formatMessage(
      messages['quick-calculations.calculation-type-count-empty']
    ),
    [DatabaseCalculationType.COUNT_UNIQUE]: formatMessage(
      messages['quick-calculations.calculation-type-count-unique']
    ),
    [DatabaseCalculationType.PERCENT_EMPTY]: formatMessage(
      messages['quick-calculations.calculation-type-percent-empty']
    ),
    [DatabaseCalculationType.PERCENT_NOT_EMPTY]: formatMessage(
      messages['quick-calculations.calculation-type-percent-not-empty']
    ),
    [DatabaseCalculationType.AVERAGE]: formatMessage(
      messages['quick-calculations.calculation-type-average']
    ),
    [DatabaseCalculationType.MIN]: formatMessage(
      messages['quick-calculations.calculation-type-min']
    ),
    [DatabaseCalculationType.MAX]: formatMessage(
      messages['quick-calculations.calculation-type-max']
    ),
  };

  return (
    <Text
      color={isButtonHeader ? 'color.text.subtlest' : 'color.text'}
      weight={isButtonHeader ? 'semibold' : 'regular'}
    >
      {type !== undefined
        ? labelMap[type]
        : formatMessage(messages['quick.calculations.placeholder-text'])}
    </Text>
  );
};
